import { useAppSelector } from "@/v2/hooks/useTypedRedux";

export const useIsAdminAsset = () => {
  return (
    useAppSelector((s) => s.auth?.adminDetails?.cityShort?.businessType) ===
    "ASSET_MANAGEMENT"
  );
};
